import { render, staticRenderFns } from "./business-inactive.component.html?vue&type=template&id=5b07ae99&scoped=true&external"
import script from "./business-inactive.component.ts?vue&type=script&lang=ts&external"
export * from "./business-inactive.component.ts?vue&type=script&lang=ts&external"
import style0 from "./business-inactive.component.scss?vue&type=style&index=0&id=5b07ae99&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b07ae99",
  null
  
)

export default component.exports